import React from 'react';
import { Button } from 'anf-core-react';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';
import { TmntText } from '../../Common';
import { textProp } from '../../../tools/customProps';
import { useTealiumTrigger } from '../../../hooks';

export const GLADLY_CHAT_FLAG_QUERY = gql`
  query GLADLY_CHAT_FLAG_QUERY {
    isGladlyChatEnabled: featureFlag(
      key: "gladly-chat",
      defaultValue: false
    )
  }
`;

export default function ChatModule({
  isChatEnabled,
  enabledText,
  disabledText,
}) {
  const launchChat = () => window?.digitalData.trigger('event:chat.openChatWindow');
  const dataAnalyticsTrackAction = useTealiumTrigger('universal', 'CHAT_WITH_US');

  const { data = {} } = useQuery(GLADLY_CHAT_FLAG_QUERY);
  const { isGladlyChatEnabled: isGladlyEnabled = false } = data;

  const handleOnClick = () => {
    launchChat();
    dataAnalyticsTrackAction();
  };

  const onGladylyChatClick = () => {
    window?.Gladly?.show();
    dataAnalyticsTrackAction();
    // TODO gladly: Invoke coresponding data analytics tracking for Gladly
  };

  const chatButton = isGladlyEnabled ? (
    <Button
      classList="gladly-customer-care-button gladly-chat-icon-button"
      theme="inverse"
      variant="tertiary-dark"
      onClick={onGladylyChatClick}
    >
      <TmntText
        testId="gladly-chat-with-us-button"
        tmnt={enabledText}
      />
    </Button>
  ) : (
    <Button
      classList="customer-care-button chat-icon-button"
      theme="inverse"
      variant="tertiary-dark"
      onClick={handleOnClick}
    >
      <TmntText
        testId="chat-with-us-button"
        tmnt={enabledText}
      />
    </Button>
  );

  return isChatEnabled
    ? chatButton
    : (
      <Button
        classList="customer-care-button chat-icon-button"
        theme="inverse"
        variant="tertiary-dark"
        isDisabled
      >
        <TmntText
          testId="chat-with-us-button-disabled"
          tmnt={disabledText}
        />
      </Button>
    );
}

ChatModule.defaultProps = {
  enabledText: undefined,
  disabledText: undefined,
};

ChatModule.propTypes = {
  isChatEnabled: PropTypes.bool.isRequired,
  enabledText: textProp,
  disabledText: textProp,
};
